import { render } from "./ClientReviews.vue?vue&type=template&id=57106b4c&scoped=true"
const script = {}

import "../../assets/css/home.css?vue&type=style&index=0&id=57106b4c&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57106b4c"]])

export default __exports__